<hw-page-header header="mdm.obs-group-01.header" class="page-header"></hw-page-header>
<nz-content class="main">
  <hw-table *ngIf="observationGroups">
    <div headerContent>
      <div style="display: flex">
        <nz-input-group [nzSuffix]="inputClear">
          <input
            nz-input
            name="filter"
            [(ngModel)]="search"
            placeholder="{{ 'mdm.obs-group-01.search' | translate }}" />
        </nz-input-group>
        <ng-template #inputClear>
          <i
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="search"
            (click)="this.search = null"></i>
        </ng-template>
        <hw-button
          [routerLink]="['add']"
          *hwPrivileged="editPrivileges"
          display="secondary"
          label="core.btn.add"></hw-button>
      </div>
    </div>
    <nz-table
      #basicTable
      [nzData]="observationGroups | textSearch : { '*': search }"
      nzSize="small"
      nzFrontPagination="false"
      nzShowPagination="false">
      <thead>
        <tr>
          <th>{{ 'mdm.obs-group-01.code' | translate }}</th>
          <th>{{ 'mdm.obs-group-01.names' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of basicTable.data">
          <td>
            <a [routerLink]="['edit', row.id]">{{ row.code }}</a>
          </td>
          <td>{{ row.names | localName }}</td>
        </tr>
      </tbody>
    </nz-table>
  </hw-table>
</nz-content>
